import React from 'react'

interface ProgressCircleProps {
	step: number
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({ step }) => {
	const totalSteps = 3
	const percentage = (step / totalSteps) * 100

	const size = 40
	const stroke = 4
	const radius = (size - stroke) / 2
	const circumference = 2 * Math.PI * radius
	const strokeDashoffset = circumference - (percentage / 100) * circumference

	return (
		<div className="flex items-center justify-center">
			<svg height={size} width={size}>
				<circle
					style={{ stroke: 'var(--progress-track)' }}
					fill="transparent"
					strokeWidth={stroke}
					r={radius}
					cx={size / 2}
					cy={size / 2}
				/>
				<circle
					stroke="url(#gradient)"
					fill="transparent"
					strokeWidth={stroke}
					strokeLinecap="round"
					strokeDasharray={circumference}
					strokeDashoffset={strokeDashoffset}
					r={radius}
					cx={size / 2}
					cy={size / 2}
					transform={`rotate(-80 ${size / 2} ${size / 2})`} // rotate start to top
					style={{ transition: 'stroke-dashoffset 0.6s ease' }}
				/>
				{/* Gradient for progress */}
				<defs>
					<linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
						<stop offset="0%" style={{ stopColor: 'var(--progress-start)' }} />
						<stop offset="100%" style={{ stopColor: 'var(--progress-end)' }} />
					</linearGradient>
				</defs>
				<text
					x="50%"
					y="50%"
					dominantBaseline="middle"
					textAnchor="middle"
					fontSize="12"
					style={{ fill: 'var(--progress-count-text, #1a1a1a)' }}
				>
					{step}/{totalSteps}
				</text>
			</svg>
		</div>
	)
}

export default ProgressCircle
